import { XRayServiceException as __BaseException } from "./XRayServiceException";
export var AnnotationValue;
(function (AnnotationValue) {
    AnnotationValue.visit = (value, visitor) => {
        if (value.NumberValue !== undefined)
            return visitor.NumberValue(value.NumberValue);
        if (value.BooleanValue !== undefined)
            return visitor.BooleanValue(value.BooleanValue);
        if (value.StringValue !== undefined)
            return visitor.StringValue(value.StringValue);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AnnotationValue || (AnnotationValue = {}));
export class InvalidRequestException extends __BaseException {
    constructor(opts) {
        super({
            name: "InvalidRequestException",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidRequestException";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidRequestException.prototype);
        this.Message = opts.Message;
    }
}
export class ThrottledException extends __BaseException {
    constructor(opts) {
        super({
            name: "ThrottledException",
            $fault: "client",
            ...opts,
        });
        this.name = "ThrottledException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ThrottledException.prototype);
        this.Message = opts.Message;
    }
}
export class RuleLimitExceededException extends __BaseException {
    constructor(opts) {
        super({
            name: "RuleLimitExceededException",
            $fault: "client",
            ...opts,
        });
        this.name = "RuleLimitExceededException";
        this.$fault = "client";
        Object.setPrototypeOf(this, RuleLimitExceededException.prototype);
        this.Message = opts.Message;
    }
}
export class InvalidPolicyRevisionIdException extends __BaseException {
    constructor(opts) {
        super({
            name: "InvalidPolicyRevisionIdException",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidPolicyRevisionIdException";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidPolicyRevisionIdException.prototype);
        this.Message = opts.Message;
    }
}
export var EncryptionStatus;
(function (EncryptionStatus) {
    EncryptionStatus["ACTIVE"] = "ACTIVE";
    EncryptionStatus["UPDATING"] = "UPDATING";
})(EncryptionStatus || (EncryptionStatus = {}));
export var EncryptionType;
(function (EncryptionType) {
    EncryptionType["KMS"] = "KMS";
    EncryptionType["NONE"] = "NONE";
})(EncryptionType || (EncryptionType = {}));
export var InsightCategory;
(function (InsightCategory) {
    InsightCategory["FAULT"] = "FAULT";
})(InsightCategory || (InsightCategory = {}));
export var InsightState;
(function (InsightState) {
    InsightState["ACTIVE"] = "ACTIVE";
    InsightState["CLOSED"] = "CLOSED";
})(InsightState || (InsightState = {}));
export var SamplingStrategyName;
(function (SamplingStrategyName) {
    SamplingStrategyName["FixedRate"] = "FixedRate";
    SamplingStrategyName["PartialScan"] = "PartialScan";
})(SamplingStrategyName || (SamplingStrategyName = {}));
export var TimeRangeType;
(function (TimeRangeType) {
    TimeRangeType["Event"] = "Event";
    TimeRangeType["TraceId"] = "TraceId";
})(TimeRangeType || (TimeRangeType = {}));
export class ResourceNotFoundException extends __BaseException {
    constructor(opts) {
        super({
            name: "ResourceNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "ResourceNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ResourceNotFoundException.prototype);
        this.Message = opts.Message;
        this.ResourceName = opts.ResourceName;
    }
}
export class LockoutPreventionException extends __BaseException {
    constructor(opts) {
        super({
            name: "LockoutPreventionException",
            $fault: "client",
            ...opts,
        });
        this.name = "LockoutPreventionException";
        this.$fault = "client";
        Object.setPrototypeOf(this, LockoutPreventionException.prototype);
        this.Message = opts.Message;
    }
}
export class MalformedPolicyDocumentException extends __BaseException {
    constructor(opts) {
        super({
            name: "MalformedPolicyDocumentException",
            $fault: "client",
            ...opts,
        });
        this.name = "MalformedPolicyDocumentException";
        this.$fault = "client";
        Object.setPrototypeOf(this, MalformedPolicyDocumentException.prototype);
        this.Message = opts.Message;
    }
}
export class PolicyCountLimitExceededException extends __BaseException {
    constructor(opts) {
        super({
            name: "PolicyCountLimitExceededException",
            $fault: "client",
            ...opts,
        });
        this.name = "PolicyCountLimitExceededException";
        this.$fault = "client";
        Object.setPrototypeOf(this, PolicyCountLimitExceededException.prototype);
        this.Message = opts.Message;
    }
}
export class PolicySizeLimitExceededException extends __BaseException {
    constructor(opts) {
        super({
            name: "PolicySizeLimitExceededException",
            $fault: "client",
            ...opts,
        });
        this.name = "PolicySizeLimitExceededException";
        this.$fault = "client";
        Object.setPrototypeOf(this, PolicySizeLimitExceededException.prototype);
        this.Message = opts.Message;
    }
}
export class TooManyTagsException extends __BaseException {
    constructor(opts) {
        super({
            name: "TooManyTagsException",
            $fault: "client",
            ...opts,
        });
        this.name = "TooManyTagsException";
        this.$fault = "client";
        Object.setPrototypeOf(this, TooManyTagsException.prototype);
        this.Message = opts.Message;
        this.ResourceName = opts.ResourceName;
    }
}
export const AliasFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AnnotationValueFilterSensitiveLog = (obj) => {
    if (obj.NumberValue !== undefined)
        return { NumberValue: obj.NumberValue };
    if (obj.BooleanValue !== undefined)
        return { BooleanValue: obj.BooleanValue };
    if (obj.StringValue !== undefined)
        return { StringValue: obj.StringValue };
    if (obj.$unknown !== undefined)
        return { [obj.$unknown[0]]: "UNKNOWN" };
};
export const ServiceIdFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ValueWithServiceIdsFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.AnnotationValue && { AnnotationValue: AnnotationValueFilterSensitiveLog(obj.AnnotationValue) }),
});
export const AnomalousServiceFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const AvailabilityZoneDetailFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BatchGetTracesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SegmentFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TraceFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BatchGetTracesResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const InsightsConfigurationFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TagFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateGroupRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GroupFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateGroupResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SamplingRuleFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateSamplingRuleRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SamplingRuleRecordFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const CreateSamplingRuleResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteGroupRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteGroupResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteResourcePolicyRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteResourcePolicyResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteSamplingRuleRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const DeleteSamplingRuleResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetEncryptionConfigRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EncryptionConfigFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetEncryptionConfigResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetGroupRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetGroupResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetGroupsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GroupSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetGroupsResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetInsightRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RequestImpactStatisticsFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const InsightFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetInsightResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetInsightEventsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const InsightEventFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetInsightEventsResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetInsightImpactGraphRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const InsightImpactGraphEdgeFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const InsightImpactGraphServiceFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetInsightImpactGraphResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetInsightSummariesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const InsightSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetInsightSummariesResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetSamplingRulesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetSamplingRulesResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetSamplingStatisticSummariesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SamplingStatisticSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetSamplingStatisticSummariesResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SamplingStatisticsDocumentFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetSamplingTargetsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SamplingTargetDocumentFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UnprocessedStatisticsFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetSamplingTargetsResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetServiceGraphRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const HistogramEntryFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ErrorStatisticsFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const FaultStatisticsFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EdgeStatisticsFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const EdgeFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ServiceStatisticsFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ServiceFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetServiceGraphResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetTimeSeriesServiceStatisticsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ForecastStatisticsFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TimeSeriesServiceStatisticsFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetTimeSeriesServiceStatisticsResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetTraceGraphRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetTraceGraphResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SamplingStrategyFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const GetTraceSummariesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const RootCauseExceptionFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ErrorRootCauseEntityFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ErrorRootCauseServiceFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ErrorRootCauseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const FaultRootCauseEntityFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const FaultRootCauseServiceFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const FaultRootCauseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const HttpFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const InstanceIdDetailFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ResourceARNDetailFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ResponseTimeRootCauseEntityFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ResponseTimeRootCauseServiceFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ResponseTimeRootCauseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TraceUserFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TraceSummaryFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.Annotations && {
        Annotations: Object.entries(obj.Annotations).reduce((acc, [key, value]) => ((acc[key] = value.map((item) => ValueWithServiceIdsFilterSensitiveLog(item))), acc), {}),
    }),
});
export const GetTraceSummariesResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListResourcePoliciesRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ResourcePolicyFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListResourcePoliciesResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListTagsForResourceRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const ListTagsForResourceResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PutEncryptionConfigRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PutEncryptionConfigResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PutResourcePolicyRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PutResourcePolicyResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const BackendConnectionErrorsFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TelemetryRecordFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PutTelemetryRecordsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PutTelemetryRecordsResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PutTraceSegmentsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UnprocessedTraceSegmentFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const PutTraceSegmentsResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TagResourceRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const TagResourceResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UntagResourceRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UntagResourceResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateGroupRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateGroupResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const SamplingRuleUpdateFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateSamplingRuleRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
export const UpdateSamplingRuleResultFilterSensitiveLog = (obj) => ({
    ...obj,
});
